export const TERMS_EFFECTIVE_DATE = 'April 20, 2026';
export const PRIVACY_EFFECTIVE_DATE = 'April 20, 2026';
export const TERMS_VERSION = '2026-04-20';

export const TERMS_OF_SERVICE = {
    title: 'GUZMAN CAREER SERVICES',
    subtitle: 'TERMS AND CONDITIONS',
    effectiveDate: TERMS_EFFECTIVE_DATE,
    sections: [
        {
            number: '1',
            title: 'Definitions',
            content: 'For purposes of this Agreement:',
            items: [
                '"Service Provider" refers to Guzman Career Services.',
                '"Client" refers to the individual engaging the Services.',
                '"Services" refer to job application, outreach, resume preparation, and placement-related activities.',
                '"Offer" refers to any formal employment offer (written or verbal) extended to the Client.',
            ],
        },
        {
            number: '2',
            title: 'Nature of Agreement (Offer-Based Engagement)',
            content: 'This Agreement is offer-based. All obligations, including payment, are tied to outcomes resulting from Services performed.\n\nAny results arising from work completed during the engagement remain attributable to the Service Provider, even if realized after the Agreement ends.',
        },
        {
            number: '3',
            title: 'Scope of Services',
            content: 'The Service Provider agrees to use commercially reasonable efforts to provide:',
            items: [
                'Submission of approximately 80–100 job applications per week',
                'Resume customization and optimization',
                'Preparation and delivery of all required resumes and materials for interviews',
                'Ongoing outreach, follow-ups, and engagement support',
            ],
            footer: 'The Service Provider does not guarantee interviews, job offers, or employment outcomes.',
        },
        {
            number: '4',
            title: 'Fees',
            content: 'Total Service Fee:\n$3,450.00 USD',
        },
        {
            number: '5',
            title: 'Payment Structure',
            items: [
                'Initial Payment: $1,250.00 USD',
                'Grace Period: 60 days with no payments required',
                'Monthly Payments: $550.00 USD due on or before the 20th',
                'Offer Trigger: Remaining balance due within 4–6 weeks upon Offer',
            ],
        },
        {
            number: '6',
            title: 'Referral Program',
            items: [
                '$100 USD per successful referral',
                'Payable only after the referred client completes full payment',
            ],
        },
        {
            number: '7',
            title: 'Term',
            content: 'Agreement ends upon Offer or after one (1) year.',
        },
        {
            number: '8',
            title: 'Offer Attribution',
            content: 'All Offers resulting directly or indirectly from Services are attributable regardless of timing.',
        },
        {
            number: '9',
            title: 'Payment Obligations Upon Offer',
            content: 'All outstanding balances must be paid within 4–6 weeks of receiving an Offer.',
        },
        {
            number: '10',
            title: 'No-Refund Policy',
            content: 'All payments are non-refundable once Services begin.',
        },
        {
            number: '11',
            title: 'Independent Offer-Based Engagement',
            content: 'Any qualifying Offer creates a binding obligation to pay, regardless of contract status.',
        },
        {
            number: '12',
            title: 'Waiver of Defenses',
            content: 'The Client waives all defenses related to timing, contract status, or awareness.',
        },
        {
            number: '13',
            title: 'Non-Circumvention',
            content: 'Any attempt to avoid payment or conceal Offers constitutes a material breach.',
        },
        {
            number: '14',
            title: 'Acknowledgment of Terms and Privacy Policy',
            content: 'By engaging with the Service Provider, creating an account, submitting payment, or continuing to use the Services, the Client expressly acknowledges and agrees to:',
            items: [
                'These Terms and Conditions',
                'The Company\'s Privacy Policy',
            ],
            footer: 'The Client understands that:\n• Both documents are legally binding\n• Both are available on the Company\'s website\n• Acceptance of one constitutes acceptance of both when engaging Services\n\nWhere presented electronically (including via website, portal, or payment page), the Client\'s selection of an "I Agree" checkbox or similar acknowledgment shall constitute full legal acceptance.',
        },
        {
            number: '15',
            title: 'Electronic Acceptance',
            content: 'This Agreement may be accepted through:',
            items: [
                'Clicking "I Agree" or similar',
                'Creating an account',
                'Submitting payment',
                'Continuing to use Services',
            ],
            footer: 'Such actions constitute a binding electronic signature.',
        },
        {
            number: '16',
            title: 'Late Payment and Default',
            content: 'Payments after the 20th are considered late.\n\nThe Service Provider may:',
            items: [
                'Pause services',
                'Restrict access',
                'Apply late fees',
            ],
            footer: 'Non-payment may result in legal action.',
        },
        {
            number: '17',
            title: 'Client Duty to Disclose Offers',
            content: 'The Client must report all Offers immediately, regardless of Service Provider awareness.',
        },
        {
            number: '18',
            title: 'Client Termination and Access Responsibilities',
            content: '2 weeks written notice required before:',
            items: [
                'Ending services',
                'Changing shared email access',
            ],
            footer: 'Changing credentials:\n• Is considered service interference\n• Does not terminate agreement\n• Does not remove payment obligations',
        },
        {
            number: '19',
            title: 'Communication Requirement',
            content: 'All employer communication must occur through the shared email account.',
        },
        {
            number: '20',
            title: 'Client Portal Access',
            content: 'The Client will have access to a secure portal containing:',
            items: [
                'Resume(s)',
                'Job description links',
                'Application materials',
                'Invoices and payment history',
            ],
            footer: 'The Client is responsible for monitoring their portal.',
        },
        {
            number: '21',
            title: 'Payment Method (Stripe – Exclusive Requirement)',
            content: 'ALL PAYMENTS MUST BE MADE THROUGH THE CLIENT PORTAL USING STRIPE.',
            items: [
                'Stripe is the only accepted payment method',
                'The portal is the official system of record',
            ],
            footer: 'Payments made outside this system:\n• Will not be accepted\n• Will not be credited\n• Do not satisfy payment obligations',
        },
        {
            number: '22',
            title: 'Governing Law and Jurisdiction',
            content: 'This Agreement is governed by the laws of the State of Texas.\n\nAll disputes must be brought exclusively in Texas courts.',
        },
        {
            number: '23',
            title: 'Legal Fees and Enforcement',
            content: 'The Client agrees to pay all costs of enforcement, including:',
            items: [
                'Attorney\'s fees',
                'Court costs',
                'Collection fees',
            ],
            footer: 'Enforceable under Texas Civil Practice and Remedies Code §38.001.',
        },
    ],
    finalAcknowledgment: {
        title: 'FINAL ACKNOWLEDGMENT',
        content: 'By using Guzman Career Services, the Client acknowledges and agrees to:',
        items: [
            'These Terms and Conditions',
            'The Privacy Policy',
            'All payment, communication, and enforcement provisions',
        ],
        footer: 'This Agreement is binding and enforceable upon engagement.',
    },
};

export const TECH2MATES_TERMS_OF_SERVICE = {
    title: 'GUZMAN CAREER SERVICES & TECH2MATES COLLABORATION',
    subtitle: 'TERMS AND CONDITIONS',
    effectiveDate: TERMS_EFFECTIVE_DATE,
    sections: [
        {
            number: '1',
            title: 'Definitions',
            content: 'For the purposes of this Agreement:',
            items: [
                '"Service Provider" refers to Guzman Career Services.',
                '"Client" refers to Tech2Mates students engaging the Services.',
                '"Services" refer to job application, outreach, resume preparation, and placement-related activities.',
                '"Offer" refers to any formal employment offer (written or verbal) extended to the Client.',
            ],
        },
        {
            number: '2',
            title: 'Nature of Agreement (Offer-Based Engagement)',
            content: 'This Agreement is strictly outcome-based. All obligations, including payment, are contingent upon results arising from Services performed.\n\nAny results derived from work completed during the engagement shall remain attributable to the Service Provider, regardless of when such results materialize.',
        },
        {
            number: '3',
            title: 'Scope of Services',
            content: 'The Service Provider agrees to use commercially reasonable efforts to provide:',
            items: [
                'Submission of approximately 80–100 job applications per week',
                'Resume customization and optimization',
                'Preparation and delivery of all required resumes and interview materials',
                'Ongoing outreach, follow-ups, and engagement support',
            ],
            footer: 'The Service Provider does not guarantee interviews, job offers, or employment outcomes.',
        },
        {
            number: '4',
            title: 'Fees',
            content: 'Total Service Fee: $3,300.00 USD',
        },
        {
            number: '5',
            title: 'Payment Structure',
            subsections: [
                {
                    subtitle: '5.1 Initial Deposit',
                    content: '$1,200.00 USD, payable as follows:',
                    items: [
                        'Two (2) installments of $600.00 USD',
                        'Full deposit must be completed within fourteen (14) days of the first payment',
                    ],
                },
                {
                    subtitle: '5.2 Remaining Balance',
                    content: '$2,100.00 USD',
                },
                {
                    subtitle: '5.3 Offer Trigger',
                    content: 'The remaining balance becomes due within four (4) to six (6) weeks upon receipt of an Offer.',
                },
            ],
        },
        {
            number: '6',
            title: 'Referral Program',
            items: [
                'Referral Fee: $100.00 USD per successful referral',
                'Payment is issued only after the referred client has completed full payment',
            ],
        },
        {
            number: '7',
            title: 'Term',
            content: 'This Agreement shall terminate upon the earlier of:',
            items: [
                'The Client receiving an Offer; or',
                'One (1) year from the Effective Date',
            ],
        },
        {
            number: '8',
            title: 'Offer Attribution',
            content: 'All Offers resulting directly or indirectly from the Services shall be attributable to the Service Provider, regardless of timing.',
        },
        {
            number: '9',
            title: 'Payment Obligations Upon Offer',
            content: 'All outstanding balances must be paid within four (4) to six (6) weeks of receiving an Offer.',
        },
        {
            number: '10',
            title: 'No-Refund Policy',
            content: 'All payments are non-refundable once Services have commenced.',
        },
        {
            number: '11',
            title: 'Independent Offer-Based Engagement',
            content: 'Any qualifying Offer creates a binding obligation to pay, irrespective of contract status at the time the Offer is received.',
        },
        {
            number: '12',
            title: 'Waiver of Defenses',
            content: 'The Client expressly waives all defenses related to:',
            items: [
                'Timing',
                'Contract status',
                'Awareness of Services performed',
            ],
        },
        {
            number: '13',
            title: 'Non-Circumvention',
            content: 'Any attempt to:',
            items: [
                'Avoid payment obligations, or',
                'Conceal Offers',
            ],
            footer: 'shall constitute a material breach of this Agreement.',
        },
        {
            number: '14',
            title: 'Acknowledgment of Terms and Privacy Policy',
            content: 'By engaging with the Service Provider (including account creation, payment submission, or continued use of Services), the Client expressly agrees to:',
            items: [
                'These Terms and Conditions',
                "The Company's Privacy Policy",
            ],
            footer: 'The Client acknowledges that:\n• Both documents are legally binding\n• Both are available on the Company\'s website\n• Acceptance of one constitutes acceptance of both when engaging Services\n\nElectronic acknowledgment (including selecting "I Agree" or equivalent) constitutes full legal acceptance.',
        },
        {
            number: '15',
            title: 'Electronic Acceptance',
            content: 'This Agreement may be accepted through any of the following actions:',
            items: [
                'Clicking "I Agree" or similar acknowledgment',
                'Creating an account',
                'Submitting payment',
                'Continuing to use the Services',
            ],
            footer: 'Such actions constitute a binding electronic signature.',
        },
        {
            number: '16',
            title: 'Late Payment and Default',
            content: 'Payments not received by the 20th of the applicable period shall be considered late.\n\nThe Service Provider reserves the right to:',
            items: [
                'Pause Services',
                'Restrict access',
                'Apply late fees',
            ],
            footer: 'Continued non-payment may result in legal action.',
        },
        {
            number: '17',
            title: 'Client Duty to Disclose Offers',
            content: 'The Client must promptly disclose all Offers, regardless of whether the Service Provider is aware of such Offers.',
        },
        {
            number: '18',
            title: 'Client Termination and Access Responsibilities',
            content: 'A minimum of two (2) weeks\' written notice is required prior to:',
            items: [
                'Terminating Services',
                'Modifying shared email access',
                'Changing account credentials',
            ],
            footer: 'Failure to comply:\n• Constitutes interference with Services\n• Does not terminate this Agreement\n• Does not relieve the Client of payment obligations',
        },
        {
            number: '19',
            title: 'Communication Requirement',
            content: 'All employer communications must be conducted through the designated shared email account.',
        },
        {
            number: '20',
            title: 'Client Portal Access',
            content: 'The Client shall have access to a secure portal containing:',
            items: [
                'Resume(s)',
                'Job description links',
                'Application materials',
                'Invoices and payment history',
            ],
            footer: 'The Client is responsible for regularly monitoring the portal.',
        },
        {
            number: '21',
            title: 'Payment Method (Stripe – Exclusive Requirement)',
            content: 'All payments must be made through the Client Portal using Stripe.',
            items: [
                'Stripe is the exclusive payment method',
                'The portal serves as the official system of record',
            ],
            footer: 'Payments made outside this system:\n• Will not be accepted\n• Will not be credited\n• Do not satisfy payment obligations',
        },
        {
            number: '22',
            title: 'Governing Law and Jurisdiction',
            content: 'This Agreement shall be governed by and construed in accordance with the laws of the State of Texas.\n\nAll disputes shall be brought exclusively in courts located within the State of Texas.',
        },
        {
            number: '23',
            title: 'Legal Fees and Enforcement',
            content: 'The Client agrees to bear all costs associated with enforcement of this Agreement, including:',
            items: [
                "Attorney's fees",
                'Court costs',
                'Collection fees',
            ],
            footer: 'This provision is enforceable under Texas Civil Practice and Remedies Code §38.001.',
        },
        {
            number: '24',
            title: 'Verification of Tech2Mates Studentship',
            content: 'All Tech2Mates students must undergo mandatory verification of their studentship status.',
            items: [
                'Verification must be completed through direct communication from Mr. Michael to the Service Provider',
                'Verification must occur prior to or at the time of engagement',
            ],
            footer: 'Failure to complete verification may result in:\n• Delay of Services\n• Suspension of Services\n• Denial of Services\n\nSuch determinations are at the sole discretion of the Service Provider.',
        },
    ],
    finalAcknowledgment: {
        title: 'FINAL ACKNOWLEDGMENT',
        content: 'By engaging Guzman Career Services, the Client acknowledges and agrees to:',
        items: [
            'These Terms and Conditions',
            'The Privacy Policy',
            'All payment, communication, and enforcement provisions',
        ],
        footer: 'This Agreement becomes binding and enforceable upon engagement.',
    },
};

export const PRIVACY_POLICY = {
    title: 'GUZMAN CAREER SERVICES',
    subtitle: 'PRIVACY POLICY',
    effectiveDate: PRIVACY_EFFECTIVE_DATE,
    sections: [
        {
            number: '1',
            title: 'Introduction',
            content: 'Guzman Career Services ("Company," "we," "us," or "our") is committed to protecting your privacy and safeguarding your personal information.\n\nThis Privacy Policy explains how we collect, use, store, and protect your information when you engage with our services, website, and client portal.\n\nBy using our services, you agree to the terms outlined in this Privacy Policy.',
        },
        {
            number: '2',
            title: 'Information We Collect',
            content: 'We may collect the following types of information:',
            subsections: [
                {
                    subtitle: 'Personal Information',
                    items: [
                        'Full name',
                        'Email address',
                        'Phone number',
                        'Resume details (work history, education, skills)',
                        'Employment preferences',
                    ],
                },
                {
                    subtitle: 'Account & Portal Information',
                    items: [
                        'Login credentials',
                        'Uploaded documents (resumes, materials)',
                        'Job application data',
                        'Communication history',
                    ],
                },
                {
                    subtitle: 'Payment Information',
                    items: [
                        'Billing details',
                        'Payment history and invoices',
                    ],
                },
            ],
            footer: 'Note: All payments are processed securely through Stripe. We do not store full credit card details.',
        },
        {
            number: '3',
            title: 'How We Use Your Information',
            content: 'We use your information to:',
            items: [
                'Provide and deliver Services',
                'Submit job applications on your behalf',
                'Communicate with employers and recruiters',
                'Manage your client portal and account',
                'Process payments and generate invoices',
                'Provide customer support',
                'Improve our services and operations',
            ],
        },
        {
            number: '4',
            title: 'Shared Email Usage',
            content: 'As part of our services:',
            items: [
                'A shared email account may be used to communicate with prospective employers',
                'All job-related communication is conducted through this account',
                'This ensures consistency, tracking, and service delivery',
            ],
            footer: 'By using our services, you consent to this communication method.',
        },
        {
            number: '5',
            title: 'Client Portal',
            content: 'You will have access to a secure client portal that may include:',
            items: [
                'Resume(s)',
                'Job descriptions and application materials',
                'Invoices and payment history',
                'Account activity',
            ],
            footer: 'You are responsible for maintaining the confidentiality of your login credentials.',
        },
        {
            number: '6',
            title: 'Payment Processing (Stripe)',
            content: 'All payments are processed through Stripe, a third-party payment processor.',
            items: [
                'Stripe handles all sensitive payment data securely',
                'We do not store full payment card information',
                'Stripe\'s use of your data is governed by their own privacy policy',
            ],
        },
        {
            number: '7',
            title: 'How We Share Information',
            content: 'We may share your information:',
            items: [
                'With employers and recruiters (as part of job applications)',
                'With service providers (e.g., Stripe for payments)',
                'When required by law or legal process',
            ],
            footer: 'We do not sell your personal information to third parties.',
        },
        {
            number: '8',
            title: 'Data Security',
            content: 'We implement reasonable administrative, technical, and physical safeguards to protect your information.\n\nHowever, no system is 100% secure. By using our services, you acknowledge this risk.',
        },
        {
            number: '9',
            title: 'Data Retention',
            content: 'We retain your information:',
            items: [
                'For the duration of your engagement',
                'As needed to fulfill legal, contractual, or operational obligations',
            ],
            footer: 'We may retain certain data even after termination for compliance and enforcement purposes.',
        },
        {
            number: '10',
            title: 'Your Responsibilities',
            content: 'You agree to:',
            items: [
                'Provide accurate and up-to-date information',
                'Maintain the security of your account credentials',
                'Use the client portal and shared email appropriately',
            ],
        },
        {
            number: '11',
            title: 'Your Rights',
            content: 'Depending on applicable law, you may have the right to:',
            items: [
                'Request access to your data',
                'Request corrections to your data',
                'Request deletion (subject to legal obligations)',
            ],
            footer: 'Requests can be made by contacting us directly.',
        },
        {
            number: '12',
            title: 'Third-Party Services',
            content: 'Our services may involve third-party platforms, including:',
            items: [
                'Stripe (payment processing)',
                'Email providers',
                'Job platforms and employer systems',
            ],
            footer: 'We are not responsible for the privacy practices of third-party services.',
        },
        {
            number: '13',
            title: 'Governing Law',
            content: 'This Privacy Policy is governed by the laws of the State of Texas.',
        },
        {
            number: '14',
            title: 'Updates to This Policy',
            content: 'We may update this Privacy Policy from time to time.\n\nUpdates will be posted on our website with the revised effective date.\n\nContinued use of our services constitutes acceptance of any updates.',
        },
        {
            number: '15',
            title: 'Contact Information',
            content: 'If you have questions about this Privacy Policy, please contact:\n\nGuzman Career Services\ninfo@guzmancareerservices.com',
        },
    ],
    acknowledgment: {
        title: 'Acknowledgment',
        content: 'By using our services, website, or client portal, you acknowledge that you have read and agree to this Privacy Policy.',
    },
};
